<template>
    <div id="app" v-cloak>
        <keep-alive :exclude="/^Detail/">
            <router-view :is-mobile="isMobile" />
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: 'App',
    data: function() {
        return {
            isMobile: false,
            winTop: 0
        }
    },
    mounted() {
        // $('body').css('background', 'red');
        const that = this;
        that.$_base_rem();
        that.isMobile = that.$_base_isMobile();
        window.onresize = function() {
            that.$_base_rem();
            that.isMobile = that.$_base_isMobile();
        };
    }
}
</script>
<style>
</style>